import React, { useState, useRef, useEffect } from "react";

const CustomRadioSelect = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  error,
  options = [],
}: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleOptionClick = (optionValue: any) => {
    onChange({ target: { name, value: optionValue } });
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedOption = options.find((opt: any) => opt.value === value);

  return (
    <div className="flex flex-col w-full relative " ref={dropdownRef}>
      <label className="block text-lg font-medium text-[#DCDCDC] mb-2">
        {label}
      </label>

      {/* Custom dropdown button */}
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        onBlur={onBlur}
        className={`flex items-center justify-between w-full px-3 py-2 border-none rounded-md text-[#F4F5F7] bg-[#2E4051] focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] ${
          error ? "border-red-500" : "border-gray-300"
        }`}
      >
        <span>{selectedOption?.label || "Select..."}</span>
        <svg
          className={`w-5 h-5 transition-transform ${
            isOpen ? "rotate-180" : ""
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {/* Custom dropdown options */}
      {isOpen && (
        <div className="scrollbar-hide absolute top-full left-0 right-0 z-10 mt-1 max-h-60 p-4 overflow-auto bg-[#2E4051] border border-gray-600 rounded-md shadow-lg">
          {options.map((option: any) => (
            <div
              key={option.value}
              onClick={() => handleOptionClick(option.value)}
              className={`flex flex-row items-center gap-2 px-3 py-2 border-b-2 border-white cursor-pointer transition-colors ${
                value === option.value
                  ? " text-white"
                  : " hover:text-[#55B7E4] text-white"
              }`}
            >
              <div className="flex h-6 w-6 border-white border-2 rounded-full items-center justify-center">
                <div
                  className={`h-3 w-3  rounded-full ${
                    value === option.value
                      ? "bg-[#008564]"
                      : "border-green border-2 hover:bg-[#008564]"
                  } `}
                ></div>
              </div>
              <div>{option.label}</div>
            </div>
          ))}
        </div>
      )}

      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
};

export default CustomRadioSelect;
